export default [
    {
        path: '/',
        component: () => import('@views/auth/login' /* webpackChunkName: "js/auth/login" */)
    },
    {
        path: '/login',
        component: () => import('@views/auth/login' /* webpackChunkName: "js/auth/login" */)
    },
    {
        path: '/password',
        component: () => import('@views/auth/password' /* webpackChunkName: "js/auth/password" */)
    },
    {
        path: '/password/reset/:token',
        component: () => import('@views/auth/reset' /* webpackChunkName: "js/auth/reset" */)
    },
    {
        path: '/get-otp',
        component: () => import('@views/auth/get-otp' /* webpackChunkName: "js/auth/get-otp" */)
    },
    {
        path: '/verify-otp',
        name: 'verify-otp',
        props: true,
        component: () => import('@views/auth/verify-otp' /* webpackChunkName: "js/auth/verify-otp" */)
    },
    {
        path: '/new-password',
        name: 'new-password',
        props: true,
        component: () => import('@views/auth/new-password' /* webpackChunkName: "js/auth/new-password" */)
    },
    {
        path: '/install',
        component: () => import('@views/install/index' /* webpackChunkName: "js/form-wizard" */)
    }
]


// WEBPACK FOOTER //
// resources/js/routers/guest.js